function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DomNode } from '@bydesign-ui/hooks';
import { Emitter } from '@bydesign-ui/hooks';
import { getObjectProperty, guid, setObjectProperty } from '@bydesign-ui/utils';
import { deleteObjectProperty } from '@bydesign-ui/utils';
import { MemCache } from '../../../models/mem-cache';
import { NestWatcher } from '../../../models/nest-watcher';
import { FormNodeType } from '../types';
import { processNestWatcherKey, processRelativeKey, wrapFunction } from '../util';
export var Form = function (_Emitter) {
  _inherits(Form, _Emitter);

  var _super = _createSuper(Form);

  function Form(options) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this);
    _this.map = {};
    var _options$scrollToFirs = options.scrollToFirstError,
        scrollToFirstError = _options$scrollToFirs === void 0 ? false : _options$scrollToFirs,
        _options$saveMemCache = options.saveMemCache,
        saveMemCache = _options$saveMemCache === void 0 ? true : _options$saveMemCache,
        _options$model = options.model,
        model = _options$model === void 0 ? {} : _options$model;
    _this.id = guid();
    _this.watcher = new NestWatcher();
    _this.root = new DomNode({
      type: FormNodeType.ROOT,
      field: '',
      id: '',
      cache: new MemCache()
    });
    _this.scrollToFirstError = scrollToFirstError;
    _this.saveMemCache = saveMemCache;
    _this.model = model;

    _this.init();

    return _this;
  }

  _createClass(Form, [{
    key: "setScrollToFirstError",
    value: function setScrollToFirstError(scroll) {
      this.scrollToFirstError = scroll;
    }
  }, {
    key: "getScrollToFirstError",
    value: function getScrollToFirstError() {
      return this.scrollToFirstError;
    }
  }, {
    key: "setSaveMemCache",
    value: function setSaveMemCache(save) {
      this.saveMemCache = save;
    }
  }, {
    key: "getSaveMemCache",
    value: function getSaveMemCache() {
      return this.saveMemCache;
    }
  }, {
    key: "getRootNode",
    value: function getRootNode() {
      return this.root;
    }
  }, {
    key: "getField",
    value: function getField(id) {
      return this.map[id];
    }
  }, {
    key: "getFieldsByPath",
    value: function getFieldsByPath(path) {
      var _this2 = this;

      var fields = this.root.getSubNodes(function (node) {
        var _node$getValue = node.getValue(),
            type = _node$getValue.type;

        if (type !== FormNodeType.FIELD) {
          return null;
        }

        return true;
      }).map(function (node) {
        var _node$getValue2 = node.getValue(),
            id = _node$getValue2.id;

        return _this2.map[id];
      }).filter(function (field) {
        return NestWatcher.keyIsMatch(path, field.getPath());
      });

      if (!fields.length) {
        console.warn("path\u4E3A".concat(path, "\u7684field\u4E0D\u5B58\u5728"));
      }

      return fields;
    }
  }, {
    key: "register",
    value: function register(field) {
      this.map[field.id] = field;
    }
  }, {
    key: "unregister",
    value: function unregister(field) {
      delete this.map[field.id];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this3 = this;

      Object.keys(this.map).forEach(function (key) {
        return _this3.map[key].dispose();
      });
    }
  }, {
    key: "disposeNode",
    value: function disposeNode(node) {
      var _node$getValue3 = node.getValue(),
          id = _node$getValue3.id;

      this.map[id].dispose();
    }
  }, {
    key: "watch",
    value: function watch(id, scope, paths, callback) {
      var _this4 = this;

      var lazy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var valueKeys = paths.map(function (path) {
        return processRelativeKey(scope || _this4.root, path);
      });
      var watchKeys = paths.map(function (path) {
        return processNestWatcherKey(scope || _this4.root, path);
      });
      var values = valueKeys.map(function (key) {
        return _this4.getPathValue(key);
      });
      this.absoluteWatch(id, watchKeys, function (changes, flags) {
        var old = values;
        values = valueKeys.map(function (key) {
          return _this4.getPathValue(key);
        });
        var updated = valueKeys.some(function (key, idx) {
          return old[idx] !== values[idx];
        });

        if (updated) {
          callback(changes, flags);
        }
      }, lazy);
    }
  }, {
    key: "absoluteWatch",
    value: function absoluteWatch(id, paths, callback) {
      var lazy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      this.watcher.register(id, paths.map(function (item) {
        return 'model.' + item;
      }), wrapFunction(callback), lazy);
    }
  }, {
    key: "unwatch",
    value: function unwatch(id) {
      this.watcher.unregister(id);
    }
  }, {
    key: "getModel",
    value: function getModel() {
      return this.model;
    }
  }, {
    key: "getPathValue",
    value: function getPathValue(path) {
      return getObjectProperty(this.model, NestWatcher.splitKey(path));
    }
  }, {
    key: "setPathValue",
    value: function setPathValue(path, value) {
      var isSilent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var res = setObjectProperty(this.model, value, NestWatcher.splitKey(path));

      if (!isSilent) {
        this.watcher.notify(['model.' + path], Object.assign(flags, {
          manual: true
        }));
      }

      return res;
    }
  }, {
    key: "deletePathValue",
    value: function deletePathValue(path) {
      deleteObjectProperty(this.model, NestWatcher.splitKey(path));
    }
  }, {
    key: "updateModel",
    value: function updateModel(model) {
      this.model = model;
      this.watcher.notify(['model']);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this5 = this;

      this.validate().then(function (success) {
        if (success) {
          _this5.emit('submit', _this5.model);

          return;
        }

        _this5.emit('submit-failed', _this5.getErrors());
      }).catch(function () {
        return console.warn('this will not reached');
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this6 = this;

      var fields = this.processNeedValidateFields();
      return Promise.all(fields.map(function (field) {
        return field.validate('force');
      })).then(function () {
        var fields = _this6.processNeedValidateFields();

        if (fields.length > 0) {
          fields[0].emit('focus');
          return false;
        }

        return true;
      });
    }
  }, {
    key: "validateField",
    value: function validateField(path) {
      var _this7 = this;

      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'manual';
      var fields = this.getFieldsByPath(path);
      return Promise.all(fields.map(function (field) {
        return field.validate(trigger);
      })).then(function () {
        var needValdateFields = _this7.processNeedValidateFields(fields);

        return !needValdateFields.length;
      });
    }
  }, {
    key: "validateFields",
    value: function validateFields(paths) {
      var _this8 = this;

      return Promise.all(paths.map(function (path) {
        return _this8.validateField(path);
      })).then(function (res) {
        return res.every(function (field) {
          return field;
        });
      });
    }
  }, {
    key: "getFieldsErrors",
    value: function getFieldsErrors(paths) {
      var _this9 = this;

      var fields = paths.reduce(function (sum, path) {
        return sum.concat(_this9.getFieldsByPath(path));
      }, []);
      return this.processNeedValidateFields(fields).map(function (item) {
        return item.getValidateError();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this10 = this;

      Object.keys(this.map).forEach(function (key) {
        return _this10.map[key].reset();
      });
    }
  }, {
    key: "resetField",
    value: function resetField(path) {
      var fields = this.getFieldsByPath(path);
      fields.forEach(function (field) {
        return field.reset();
      });
    }
  }, {
    key: "resetFields",
    value: function resetFields(paths) {
      var _this11 = this;

      paths.forEach(function (path) {
        return _this11.resetField(path);
      });
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      return this.processNeedValidateFields().map(function (item) {
        return item.getValidateError();
      });
    }
  }, {
    key: "dispatchValidateResult",
    value: function dispatchValidateResult(key, node, result) {
      var scope = node.parentNode;

      while (scope != null) {
        var _scope$getValue = scope.getValue(),
            id = _scope$getValue.id,
            type = _scope$getValue.type;

        if (type === FormNodeType.GROUP) {
          var field = this.map[id];

          if (field && field.isGroup()) {
            field.processValidateResult(id, result);
          }
        }

        scope = scope.parentNode;
      }
    }
  }, {
    key: "processNeedValidateFields",
    value: function processNeedValidateFields(needFields) {
      var _this12 = this;

      var fields = needFields;

      if (!fields) {
        fields = this.root.getSubNodes(function (node) {
          var _node$getValue4 = node.getValue(),
              type = _node$getValue4.type;

          if (type !== FormNodeType.FIELD) {
            return null;
          }

          return true;
        }).map(function (node) {
          var _node$getValue5 = node.getValue(),
              id = _node$getValue5.id;

          return _this12.map[id];
        });
      }

      return fields.filter(function (field) {
        var _field$getFieldInfo = field.getFieldInfo(),
            valid = _field$getFieldInfo.valid,
            partial = _field$getFieldInfo.partial;

        return !valid || partial;
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this13 = this;

      this.absoluteWatch(this.id, ['*'], function (changes) {
        _this13.emit('model-change', _this13.getModel());

        _this13.emit('values-change', changes.map(function (fieldPath) {
          return fieldPath.replace(/^model\./, '');
        }));
      });
    }
  }]);

  return Form;
}(Emitter);